export const ANALYTIC_SETUP = 'ANALYTIC_SETUP';
export const ANALYTIC_DISMANTLE = 'ANALYTIC_DISMANTLE';

export function requestAnalyticSetUp(analyticsId) {
  return {
    type: ANALYTIC_SETUP,
    analyticsId
  };
}

export function requestAnalyticDismantle() {
  return {
    type: ANALYTIC_DISMANTLE
  };
}
